import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { Dialog } from '@material-ui/core';
import { EAA_Btn } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';

class App extends Component {
  state={ canClick: true, dotNum: 0 }
  componentDidUpdate (preProps) {
    const { res_putActiveCheck: preRes_putActiveCheck = {} } = preProps;
    const { res_putActiveCheck = {} } = this.props;
    if (Object.keys(preRes_putActiveCheck).length === 0 && Object.keys(res_putActiveCheck).length > 0) {
      this.setState({ canClick: true });
      clearInterval(this.timer);
    }
  }

  startCount=() => {
    this.timer = setInterval(() => {
      const { dotNum } = this.state;
      if (dotNum === 6) this.setState({ dotNum: 0 });
      else this.setState({ dotNum: dotNum + 1 });
    }, 300);
  }

  renderCheckDialog=() => {
    const { onClose, putActiveCheck, id } = this.props;
    const { canClick, dotNum } = this.state;
    const returnDot = () => {
      let t = '';
      for (let i = 0; i < dotNum; i++) {
        t = `${t}.`;
      }
      return t;
    };
    return (
      <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <svg style={{ marginTop: 111, marginBottom: 32 }} width="155" height="103" viewBox="0 0 155 103" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M103.333 0H51.6667C23.1424 0 0 23.0677 0 51.5C0 79.9323 23.1424 103 51.6667 103H103.333C131.858 103 155 79.9323 155 51.5C155 23.0677 131.858 0 103.333 0ZM103.333 85.8333C84.2812 85.8333 68.8889 70.4638 68.8889 51.5C68.8889 32.5094 84.3082 17.1667 103.333 17.1667C122.385 17.1667 137.778 32.5362 137.778 51.5C137.778 70.4906 122.358 85.8333 103.333 85.8333Z" fill="#511496" />
        </svg>

        <div style={{ fontSize: 25 }}>確認要啟動清查嗎？</div>
        <div style={{ color: '#F40000', fontSize: 25, marginBottom: 25, marginTop: 8 }}>{canClick ? '啟用後將開始作業，無法關閉。' : `啟用中${returnDot()}`}</div>
        <div style={{ display: 'flex' }}>
          <EAA_Btn disabled={!canClick} text='取消' style={{ height: 47, width: 165, marginRight: 16 }} backgroundColor={ canClick ? leftColor : 'gray'} onClick={onClose} />
          <EAA_Btn disabled={!canClick} text='確認' style={{ height: 47, width: 165 }} backgroundColor={canClick ? rightColor : 'gray'} onClick={() => { this.setState({ canClick: false }); this.startCount(); putActiveCheck(id); }} />
        </div>
      </div>
    );
  }

  renderSucDialog=() => {
    const { res_putActiveCheck = {}, clearKey, search, onClose } = this.props;
    return (
      <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <svg style={{ marginTop: 111, marginBottom: 32 }} width="155" height="103" viewBox="0 0 155 103" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M103.333 0H51.6667C23.1424 0 0 23.0677 0 51.5C0 79.9323 23.1424 103 51.6667 103H103.333C131.858 103 155 79.9323 155 51.5C155 23.0677 131.858 0 103.333 0ZM103.333 85.8333C84.2812 85.8333 68.8889 70.4638 68.8889 51.5C68.8889 32.5094 84.3082 17.1667 103.333 17.1667C122.385 17.1667 137.778 32.5362 137.778 51.5C137.778 70.4906 122.358 85.8333 103.333 85.8333Z" fill="#511496" />
        </svg>

        <div style={{ fontSize: 25, marginBottom: 77 }}>
          {res_putActiveCheck.status === '200' && '啟動清查成功'}
          {res_putActiveCheck.status !== '200' && (res_putActiveCheck.message || '啟動清查失敗')}
        </div>
        <EAA_Btn text='確認' style={{ height: 47, width: 165 }} backgroundColor={rightColor} onClick={() => { search(); onClose(); clearKey('PutActiveCheck'); }} />
      </div>
    );
  }

  render () {
    const { open = false, res_putActiveCheck = {} } = this.props;
    return (
      <Dialog
        PaperComponent={Object.keys(res_putActiveCheck).length > 0 ? this.renderSucDialog : this.renderCheckDialog}
        open={open}
      />
    );
  }
}

const mapStateToProps = state => ({
  res_putActiveCheck: state.data.PutActiveCheck,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  putActiveCheck: id => Actions.putActiveCheck(dispatch, { id }),
});
const APP = connect(mapStateToProps, mapDispatchToProps)(App);

const UserCheckActive =
(props = {
  open: false,
  onClose: () => {},
  id: '',
  search: () => {},
}) => <APP {...props} />;

export default UserCheckActive;
